import React from 'react'
import styled from 'styled-components'
import {getAppStoreLink, getPlayStoreLink, useHistory} from 'utils'
import {IMAGE_ASSET} from 'consts'
import {useTranslation} from 'i18n'
import {Icon, Image, Link, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${convertUnit(20)};
`
const StyledStoreImagesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${convertUnit(25)};
`

const StyledImg = styled(Image)`
  height: ${convertUnit(60)};
  width: ${convertUnit(120)};
  object-fit: contain;
`

const StyledLink = styled.a`
  text-decoration: none;
`
const StyledImageContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: ${convertUnit(200)};
  display: flex;
  justify-content: center;
  align-items: center;
`
const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: contain;
`
const StyledParagraph = styled(Paragraph)`
  text-align: center;
`
const StyledSectionLogin = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`
const StyledLogin = styled(Paragraph)`
  margin-left: ${convertUnit(9)};
`
const StyledBackIconCursor = styled.div`
  cursor: pointer;
  width: fit-content;
`
export default function AuthEasySignupDisabled() {
  const {translate} = useTranslation()
  const history = useHistory()
  const googlePlayImg = IMAGE_ASSET('giftshop', 'google-play-icon.png')
  const appStoreImg = IMAGE_ASSET('giftshop', 'app-store-icon.png')
  return (
    <StyledContainer>
      <StyledBackIconCursor>
        <Icon
          type="back"
          size={20}
          color="primary_5"
          onClick={history.goBack}
        />
      </StyledBackIconCursor>
      <StyledParagraph fontSize="xl" fontWeight="bold">
        {translate('global:register')}
      </StyledParagraph>
      <StyledImageContainer>
        <StyledImage src={IMAGE_ASSET('giftshop', 'selfie-boy.png')} alt="" />
      </StyledImageContainer>
      <StyledParagraph fontSize="m" fontWeight="medium" color="gray_5">
        {translate('auth:registerCreateAccountThroughMobileApp')}
      </StyledParagraph>
      <StyledStoreImagesContainer>
        <StyledLink href={getPlayStoreLink()} target="_blank">
          <StyledImg src={googlePlayImg} alt="google-play" />
        </StyledLink>
        <StyledLink href={getAppStoreLink()} target="_blank">
          <StyledImg src={appStoreImg} alt="app-store" />
        </StyledLink>
      </StyledStoreImagesContainer>
      <StyledSectionLogin>
        <Paragraph fontSize="m" color="gray_3">
          {translate('auth:registerIdentifierAlreadyHaveAnAccount')}
        </Paragraph>
        <Link to="auth_login">
          <StyledLogin
            fontSize="m"
            fontWeight="medium"
            className="pressable"
            color="primary_5">
            {translate('global:login')}
          </StyledLogin>
        </Link>
      </StyledSectionLogin>
    </StyledContainer>
  )
}
